
<div class="app-page">
    <h4>{{'SCHEDULE.COMING' | translate | uppercase}}</h4>
    <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
  @if (this.isLoading || !this.schedule) {
    <mat-progress-bar mode="query"></mat-progress-bar>
  }@else {
    @for(day of (this.schedule.EventList | groupEventByUTCDatePipe); track day.EventStartUTC) {
      <div style="display: flex; flex-direction: row; align-items: start;">
      <div class="day" >        
        {{day.EventStartUTC+'Z' | date: 'E' }}
        <span style="font-size: small; color: gray;" >{{day.EventStartUTC+'Z' | date: 'dd MMM' }}</span>
      </div>
      <div style="display: flex; flex-direction: column; flex-grow: 1;">
      @for(event of day.Events; track event.EventId) {
        
        @if (event.EventType === 'GAME') {
          <app-game-event [Event]="event" (deleteEvent)="deleteEventFromCalendar($event)"></app-game-event>
          
        }
        @if (event.EventType === 'EVENT') {
          <app-generic-event [Event]="event"></app-generic-event>
          
        }
      }   
      </div>
      </div>
  }@empty {
    <div>{{'SCHEDULE.NO_COMING_EVENTS' | translate}}</div>
  }
}
</div>

  
    
  



